import type { ReactNode } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import CircularProgress from '@mui/material/CircularProgress';

interface InfiniteScrollListProps {
    // Off (e.g. on desktop, which pages instead) renders the children as-is.
    enabled: boolean;
    loaded: number;
    total: number;
    onLoadMore: () => void;
    children: ReactNode;
}

/** Loads more rows as the user scrolls; used by the record tables on mobile. */
function InfiniteScrollList({ enabled, loaded, total, onLoadMore, children }: InfiniteScrollListProps) {
    if (!enabled) return <>{children}</>;

    return (
        <InfiniteScroll
            dataLength={loaded}
            next={onLoadMore}
            hasMore={loaded < total}
            loader={
                <div className='flex w-full justify-center py-6'>
                    <CircularProgress size={24} />
                </div>
            }
        >
            {children}
        </InfiniteScroll>
    );
}

export default InfiniteScrollList;
